import { MapFromDTO, MetadataEntity } from '@bp/shared/models/metadata';

export class MerchantBillingPortal extends MetadataEntity {

	@MapFromDTO()
	url!: string;

}
